import { Message } from '../objects/message';
import { Version } from '../objects/version';
import { User } from '../objects/user';
import { VersionFeedback } from './version-feedback';
import { VersionShare } from './version-share.model';

export enum VersionShareFeedbackMessageType {
  TEXT_MESSAGE_TYPE = "text", // default text message [with files] leaved by users in feedback
  APPROVAL_MESSAGE_TYPE = "approval", // rejected or approved built message
  UPLOADED_MESSAGE_TYPE = "uploaded", // the uploaded version built message
}
/**
 * this is a new interface to manage several type of wrapped messages
 * It includes all bubbles inside along the user name. 
 * of types VersionShareFeedbackMessageType
 * @interface
 * @message could be a message object or a string message
 * 
 */
export interface VersionShareFeedbackMessage {
  uuid: string; //uuidv4 string
  type?: VersionShareFeedbackMessageType;
  message?: Message | string;
  version_share?: VersionShare; // current version share for the status not when real feedback message
  user_version_shares?: Array<VersionShare>; // bubbles. (how to manage this when null?)
  date: string;
  user?: User; // Common user property
  version: Version; // the origin   version where the message needs to be.
}
